import React from 'react';

export const SearchIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" {...props}>
        <path
            fill="currentColor"
            d="M9.858 0a9.85 9.85 0 00-8.012 4.116 9.872 9.872 0 005.137 15.19 9.849 9.849 0 008.862-1.601l6.9 6.907A1.317 1.317 0 0025 23.685a1.322 1.322 0 00-.384-.935l-6.9-6.907A9.873 9.873 0 0015.06 1.478 9.851 9.851 0 009.858 0zm0 2.631c1.909.006 3.737.77 5.084 2.125a7.216 7.216 0 01-.016 10.192 7.203 7.203 0 01-10.183 0 7.216 7.216 0 01-.016-10.192 7.203 7.203 0 015.085-2.125h.046z"
        />
    </svg>
);
